var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badge)?_c('div',[_c('h4',[_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(" "+_vm._s(_vm.$t("status"))+" - "+_vm._s(_vm.$t(_vm.badge.label))+" ")])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }